
let dataLayerArray = [];

function isElementInViewPort(element){
	let rect = element.getBoundingClientRect();
	let viewPortBottom = window.innerHeight || document.documentElement.clientHeight;
	let viewPortRight = window.innerWidth || document.documentElement.clientWidth;

	let isTopInViewPort = rect.top >= 0,
		isLeftInViewPort = rect.left >= 0,
		isBottomInViewPort = rect.bottom <= viewPortBottom,
		isRightInViewPort = rect.right <= viewPortRight;

	return (isTopInViewPort && isLeftInViewPort && isBottomInViewPort && isRightInViewPort);
}

export function dataLayerInit() {

	if ( document.body.classList.contains('page-template-template-pay-online-thankyou') ) {
		window.dataLayer.push({
			"event": "pay_online",
			"form_state": "success"
		});		
	}

	if ( document.body.classList.contains('single-property') ) {

		let dataLayerProperty = document.querySelector('article.single-property');
		let dataLayerItemId = dataLayerProperty.getAttribute('datalayer-item_id');
		let dataLayerItemName = dataLayerProperty.getAttribute('datalayer-item_name');			
		let dataLayerItemCategory1 = dataLayerProperty.getAttribute('datalayer-category');
		let dataLayerItemCategory2 = dataLayerProperty.getAttribute('datalayer-category_2');
		let dataLayerItemCategory3 = dataLayerProperty.getAttribute('datalayer-category_3');
		let dataLayerItemListId = dataLayerProperty.getAttribute('datalayer-item_list_id');
		let dataLayerItemListName = dataLayerProperty.getAttribute('datalayer-item_list_name');
		let dataLayerItemVariant = dataLayerProperty.getAttribute('datalayer-item_variant');
		let dataLayerPrice = dataLayerProperty.getAttribute('datalayer-price');
		let dataLayerQuantity = dataLayerProperty.getAttribute('datalayer-quantity');

		window.dataLayer.push({
			"event": "view_item",
			"ecommerce": {
				"currency": "GBP",
				"value": dataLayerQuantity,
				"items": [
					{
						"item_id": dataLayerItemId,
						"item_name": dataLayerItemName,
						"index": 1,
						"item_category": dataLayerItemCategory1,
						"item_category_2": dataLayerItemCategory2,
						"item_category_3": dataLayerItemCategory3,
						"item_list_id": dataLayerItemListId,
						"item_list_name": dataLayerItemListName,
						"item_variant": dataLayerItemVariant,
						"price": dataLayerPrice,
						"quantity": dataLayerQuantity,
					}
				],
			}
		});

	}

	let propertyFilters = document.querySelector('.datalayer-filters');

	if ( propertyFilters ) {		
		
		let dataLayerTenantType = propertyFilters.getAttribute('datalayer-tenant_type');
		let dataLayerArea = propertyFilters.getAttribute('datalayer-area');			
		let dataLayerBeds = propertyFilters.getAttribute('datalayer-beds');
		let dataLayerPrice = propertyFilters.getAttribute('datalayer-price');
		let dataLayerBathrooms = propertyFilters.getAttribute('datalayer-bathrooms');
		let dataLayerWc = propertyFilters.getAttribute('datalayer-wc');
		let dataLayerUniversity = propertyFilters.getAttribute('datalayer-university');		

		if ( dataLayerUniversity ) {

			window.dataLayer.push({
				"event": "property_search",
				"form_state": "success",
				"tenant_type": dataLayerTenantType,
				"area": dataLayerArea,
				"beds": dataLayerBeds,
				"price": dataLayerPrice,
				"bathrooms": dataLayerBathrooms,
				"wc": dataLayerWc,	
				"university": dataLayerUniversity,
			})

		} else {

			window.dataLayer.push({
				"event": "property_search",
				"form_state": "success",
				"tenant_type": dataLayerTenantType,
				"area": dataLayerArea,
				"beds": dataLayerBeds,
				"price": dataLayerPrice,
				"bathrooms": dataLayerBathrooms,
				"wc": dataLayerWc,							
			})

		}

	}

	let dataLayerProperty = document.querySelectorAll('.datalayer-property');		

	// If properties exist, scroll by miniscule amount 
	// to ensure dataLayerScroll() fires on load.

	if ( dataLayerProperty ) {
		window.scrollBy(0, 1);
		window.scrollBy(0, -1);
	}

	for ( let i = 0; i < dataLayerProperty.length; i++ ) {

		if ( dataLayerProperty === undefined ) {
			return;
		}
	
		let dataLayerItemId = dataLayerProperty[i].getAttribute('datalayer-item_id');
		let dataLayerItemName = dataLayerProperty[i].getAttribute('datalayer-item_name');			
		let dataLayerItemCategory1 = dataLayerProperty[i].getAttribute('datalayer-category');
		let dataLayerItemCategory2 = dataLayerProperty[i].getAttribute('datalayer-category_2');
		let dataLayerItemCategory3 = dataLayerProperty[i].getAttribute('datalayer-category_3');
		let dataLayerItemListId = dataLayerProperty[i].getAttribute('datalayer-item_list_id');
		let dataLayerItemListName = dataLayerProperty[i].getAttribute('datalayer-item_list_name');
		let dataLayerItemVariant = dataLayerProperty[i].getAttribute('datalayer-item_variant');
		let dataLayerPrice = dataLayerProperty[i].getAttribute('datalayer-price');
		let dataLayerQuantity = dataLayerProperty[i].getAttribute('datalayer-quantity');

		dataLayerProperty[i].querySelector('a').addEventListener('click', function() {				
			window.dataLayer.push({
				"event": "select_item",
				"ecommerce": {
					"item_list_id": dataLayerItemListId,
					"item_list_name": dataLayerItemListName,
					"items": [
						{
							"item_id": dataLayerItemId,
							"item_name": dataLayerItemName,
							"index": i,
							"item_category": dataLayerItemCategory1,
							"item_category_2": dataLayerItemCategory2,
							"item_category_3": dataLayerItemCategory3,
							"item_list_id": dataLayerItemListId,
							"item_list_name": dataLayerItemListName,
							"item_variant": dataLayerItemVariant,
							"price": dataLayerPrice,
							"quantity": dataLayerQuantity,
						}
					],
				}
			});		
		});

		dataLayerProperty[i].querySelector('.property-card__bookmark').addEventListener('click', function() {
			
			if ( dataLayerProperty[i].classList.contains('property-card--saved') ) {

				window.dataLayer.push({
					"event": "remove_from_wishlist",
					"ecommerce": {
						"item_list_id": dataLayerItemListId,
						"item_list_name": dataLayerItemListName,
						"items": [
							{
								"item_id": dataLayerItemId,
								"item_name": dataLayerItemName,
								"index": i,
								"item_category": dataLayerItemCategory1,
								"item_category_2": dataLayerItemCategory2,
								"item_category_3": dataLayerItemCategory3,
								"item_list_id": dataLayerItemListId,
								"item_list_name": dataLayerItemListName,
								"item_variant": dataLayerItemVariant,
								"price": dataLayerPrice,
								"quantity": dataLayerQuantity,
							}
						],
					}
				});			

			} else {		

				window.dataLayer.push({
					"event": "add_to_wishlist",
					"ecommerce": {
						"item_list_id": dataLayerItemListId,
						"item_list_name": dataLayerItemListName,
						"items": [
							{
								"item_id": dataLayerItemId,
								"item_name": dataLayerItemName,
								"index": i,
								"item_category": dataLayerItemCategory1,
								"item_category_2": dataLayerItemCategory2,
								"item_category_3": dataLayerItemCategory3,
								"item_list_id": dataLayerItemListId,
								"item_list_name": dataLayerItemListName,
								"item_variant": dataLayerItemVariant,
								"price": dataLayerPrice,
								"quantity": dataLayerQuantity,
							}
						],
					}
				
				});				

			}

		});

	}

}

export function dataLayerScroll() {

	let dataLayerProperty = document.querySelectorAll('.datalayer-property');

	for ( let i = 0; i < dataLayerProperty.length; i++ ) {

		if ( dataLayerProperty === undefined ) {
			return;
		}

		let dataLayerItemId = dataLayerProperty[i].getAttribute('datalayer-item_id');
		let dataLayerItemName = dataLayerProperty[i].getAttribute('datalayer-item_name');			
		let dataLayerItemCategory1 = dataLayerProperty[i].getAttribute('datalayer-category');
		let dataLayerItemCategory2 = dataLayerProperty[i].getAttribute('datalayer-category_2');
		let dataLayerItemCategory3 = dataLayerProperty[i].getAttribute('datalayer-category_3');
		let dataLayerItemListId = dataLayerProperty[i].getAttribute('datalayer-item_list_id');
		let dataLayerItemListName = dataLayerProperty[i].getAttribute('datalayer-item_list_name');
		let dataLayerItemVariant = dataLayerProperty[i].getAttribute('datalayer-item_variant');
		let dataLayerPrice = dataLayerProperty[i].getAttribute('datalayer-price');
		let dataLayerQuantity = dataLayerProperty[i].getAttribute('datalayer-quantity');

		
		if ( isElementInViewPort( dataLayerProperty[i] ) && ! dataLayerArray.includes(i) ) {						

			window.dataLayer.push({
				"event": "view_item_list",
				"ecommerce": {
					"item_list_id": dataLayerItemListId,
					"item_list_name": dataLayerItemListName,
					"items": [
						{
							"item_id": dataLayerItemId,
							"item_name": dataLayerItemName,
							"index": i,
							"item_category": dataLayerItemCategory1,
							"item_category_2": dataLayerItemCategory2,
							"item_category_3": dataLayerItemCategory3,
							"item_list_id": dataLayerItemListId,
							"item_list_name": dataLayerItemListName,
							"item_variant": dataLayerItemVariant,
							"price": dataLayerPrice,
							"quantity": dataLayerQuantity,
						}
					],
				}
			});
			dataLayerArray.push(i);
		}

	}

}